import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';
import ClassDetailsPage from './pages/classes/ClassDetailsPage';
import ClassesPage from './pages/classes/ClassesPage';
import ExamDetailsPage from './pages/exams/ExamDetailsPage';
import ExamsPage from './pages/exams/ExamsPage';
import HomePage from './pages/HomePage';
import ChallengeDetailsPage from './pages/challenges/ChallengeDetailsPage';
import ChallengesPage from './pages/challenges/ChallengesPage';
import HomeworkDetailsPage from './pages/homeworks/HomeworkDetailsPage';
import HomeworksPage from './pages/homeworks/HomeworksPage';
import LoginPage from './pages/auth/LoginPage';
import NotificationDetailsPage from './pages/notifications/NotificationDetailsPage';
import NotificationsPage from './pages/notifications/NotificationsPage';
import ParentPasswordGate from './components/ParentPasswordGate';
import ParentsPage from './pages/parents/ParentsPage';
import CalendarPage from './pages/calendar/CalendarPage';
import GradeDetailsPage from './pages/grades/GradeDetailsPage';
import GradesPage from './pages/grades/GradesPage';
import ContentDetailsPage from './pages/contents/ContentDetailsPage';
import ContentsPage from './pages/contents/ContentsPage';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/classes" element={<ClassesPage />} />
                <Route path="/classes/:classId" element={<ClassDetailsPage />} />
                <Route path="/exams" element={<ExamsPage />} />
                <Route path="/exams/:examId" element={<ExamDetailsPage />} />
                <Route path="/homeworks" element={<HomeworksPage />} />
                <Route path="/homeworks/:homeworkId" element={<HomeworkDetailsPage />} />
                <Route path="/challenges" element={<ChallengesPage />} />
                <Route path="/challenges/:challengeId" element={<ChallengeDetailsPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/notifications/:notificationId" element={<NotificationDetailsPage />} />
                <Route
                  path="/parents"
                  element={
                    <ParentPasswordGate>
                      <ParentsPage />
                    </ParentPasswordGate>
                  }
                />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/grades" element={<GradesPage />} />
                <Route path="/grades/:reportCardId" element={<GradeDetailsPage />} />
                <Route path="/contents" element={<ContentsPage />} />
                <Route path="/contents/:contentId" element={<ContentDetailsPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
